import { Attributes, DateUtils, Misc, Model, Rules, Validation } from '@singularsystems/neo-core';

export default class FundingCriteria extends Model.CriteriaBase {
    static typeName = "FundingCriteria";

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public startDate: Date | null = DateUtils.monthStart(DateUtils.today());

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date | null = DateUtils.today();

    public allowUnauthorised: boolean = false;

    @Attributes.Nullable()
    public entityId: number | null = null;

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<FundingCriteria>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Funding Criteria";
    }
}